@if (lazyLoadingService.$isLoading | async) {
  <div class="fixed top-0 left-0 w-full h-full bg-t-surface flex justify-center items-center z-50">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
